import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/choosekia/_components/choose-kia.tsx");
